import { EMPTY_STRING } from 'constants/constants';

export const ADDRESS_DROPDOWN_LIST_ITEM_TEST_ID = 'ADDRESS_DROPDOWN_LIST_ITEM_TEST_ID';
export const ADDRESS_DROPDOWN_TEST_ID = 'ADDRESS_DROPDOWN_TEST_ID';
export const ADDRESS_DROPDOWN_LIST_TEST_ID = 'ADDRESS_DROPDOWN_LIST_TEST_ID';
export const ADDRESS_DROPDOWN_INPUT_TEST_ID = 'ADDRESS_DROPDOWN_INPUT_TEST_ID';
export const SEARCH_ADDRESS_FORM_TEST_ID = 'SEARCH_ADDRESS_FORM_TEST_ID';
export const SEARCH_ADDRESS_BTN_TEST_ID = 'SEARCH_ADDRESS_BTN_TEST_ID';
export const ADDRESS_DROPDOWN_INPUT_ERROR_TEST_ID = 'ADDRESS_DROPDOWN_INPUT_ERROR_TEST_ID';

export const INITIAL_ADDRESS_DATA = { value: EMPTY_STRING, error: EMPTY_STRING };
